import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { updateCustomerData } from "../../../services/customer";
import { CircularProgress } from "@mui/material";
import './ProfilePage.css';
export default function CustomerProfilePage() {
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { user, token, setUserData } = useAuth();

    const [formData, setFormData] = useState({ ...user });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData(prev => ({ ...prev, image: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSave = async () => {
        setIsLoading(true);
        try {
            const res = await updateCustomerData(token, formData);
            setUserData(res.data);
            setIsEditing(false);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page">
            <div className="content-view">
                <div className="profile-header" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '15px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <div style={{ height: '100%' }}>
                            <div style={{ fontSize: 25, color: 'var(--clr-text-main)', margin: 0 }}>{user.name}</div>
                            <p style={{ margin: 0, color: 'var(--clr-text-main)' }}>{user.email || '-'}</p>
                        </div>
                    </div>
                </div>

                <div className="profile-info" style={{ marginTop: '20px' }}>
                    <div className="info-row" style={rowStyle}>
                        <span style={labelStyle}>الاسم</span>
                        {isEditing ? (
                            <input name="name" value={formData.name} onChange={handleChange} style={inputStyle} />
                        ) : (
                            <span style={valueStyle}>{user.name}</span>
                        )}
                    </div>

                    <div className="info-row" style={rowStyle}>
                        <span style={labelStyle}>رقم الجوال</span>
                        <span style={valueStyle}>{user.phone || "-"}</span>
                    </div>
                </div>

                <div className="profile-actions">
                    {isEditing ? (
                        <button
                            className='btn outline-primary'
                            onClick={handleSave}
                            disabled={isLoading}
                            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {isLoading && <CircularProgress size={18} />}
                            حفظ التغييرات
                        </button>
                    ) : (
                        <button className='btn filled' onClick={() => setIsEditing(true)}>تعديل</button>
                    )}
                </div>
            </div>
        </div>
    );
}


// 🔧 Inline styles for reusability
const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '25px',
    borderBottom: '1px solid #f0f0f0'
};

const labelStyle = {
    color: 'var(--clr-text-main)',
}

const valueStyle = {
    color: 'var(--clr-text-secondary)',
};

const inputStyle = {
    flex: 1,
    textAlign: 'center',
    padding: '6px 10px',
    border: '1px solid var(--clr-primary)',
    borderRadius: '6px',
    maxWidth: '200px',
    color: '#737373'
};
